var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_18616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 8.47078V15.5292H22.5881V18.353H21.1763V19.7648H19.7648V21.1763H18.353V22.5881H15.5292V24H8.47078V22.5881H5.64703V21.1763H4.23516V19.7648H2.82375V18.353H1.41188V15.5292H0V8.47078H1.41188V5.64703H2.82375V4.23516H4.23516V2.82375H5.64703V1.41188H8.47078V0H15.5292V1.41188H18.353V2.82375H19.7648V4.23516H21.1763V5.64703H22.5881V8.47078H24Z",
    fill: "#4C0042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5884 8.46941V15.5279H21.1765V18.3516H19.7651V19.7635H18.3532L17.6473 20.4689H6.3532L5.64727 19.7635H4.23539V18.3516H2.82398V15.5279H1.41211V8.46941H2.82398V5.64566H4.23539V4.23379H5.64727L6.3532 3.52832H17.6473L18.3532 4.23379H19.7651V5.64566H21.1765V8.46941H22.5884Z",
    fill: "#FFED00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0587 7.76348L18.3528 8.46941H16.9409V7.05754H15.529V5.64566H8.47061V7.05754H7.05873V8.46941H5.64686L4.94092 7.76348L5.64686 7.05754L7.05873 5.6466V5.64566L8.47061 4.23473V4.23379L9.17654 3.52832H14.8231L15.529 4.23379V4.23473L16.9409 5.64566V5.6466L18.3528 7.05754L19.0587 7.76348Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 19.765V21.1764H15.5292V22.5883H8.47072V21.1764H5.64697V19.765H7.05885L7.76479 19.0596L8.47072 19.765L9.17666 20.4705H14.8232L15.5292 19.765L16.2351 19.0596L16.941 19.765H18.3529Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 2.82398V4.23539H16.941L16.2351 4.94133L15.5292 4.23633L14.8237 3.52992H9.17619L8.47072 4.23633L7.76479 4.94133L7.05885 4.23539H5.64697V2.82398H8.47072V1.41211H15.5292V2.82398H18.3529Z",
    fill: "#FFF69E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47046 2.82422H15.5289V4.23562H8.47046V2.82422Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5288 4.23535H16.9407V5.64723H15.5288V4.23535Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9409 5.64746H18.3528V7.05934H16.9409V5.64746Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.353 7.05957H19.7649V8.47145H18.353V7.05957Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7644 8.47168H21.1758V15.5301H19.7644V8.47168Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.353 15.5283H19.7649V16.9402H18.353V15.5283Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9409 16.9404H18.3528V18.3523H16.9409V16.9404Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5288 18.3525H16.9407V19.7644H15.5288V18.3525Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47046 19.7646H15.5289V21.1761H8.47046V19.7646Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05835 18.3525H8.47023V19.7644H7.05835V18.3525Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64697 16.9404H7.05885V18.3523H5.64697V16.9404Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23486 15.5283H5.64674V16.9402H4.23486V15.5283Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82349 8.47168H4.23489V15.5301H2.82349V8.47168Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23486 7.05957H5.64674V8.47145H4.23486V7.05957Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64697 5.64746H7.05885V7.05934H5.64697V5.64746Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05835 4.23535H8.47023V5.64723H7.05835V4.23535Z",
    fill: "#9D1560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12012 16.1384V7.8584H11.2115V14.1327H15.3944V16.1384H9.12012Z",
    fill: "#9D1560"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_18616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/Coin.ef6962c0c5daa4d7cdbfd9cf8f58b3b2.svg";
export { ForwardRef as ReactComponent };